const {
	MAIN_EASING,
	DELAY_DEBOUNCE,
	CLASS_NO_DISPLAY,
} = require('../../../../js/consts');
const {
	default: { slowDelay, breakSmall },
} = require('../../../../js/sass-variables');
const {
	stuttering,
	default: onWidthResize,
} = require('../../../../js/onWidthResize');
const {
	getNumber,
	mediaQueryMin,
	trackGtm4,
} = require('../../../../js/functions');
const asyncImport = require('util/asyncImport').default;

const duration = getNumber(slowDelay) * 1000;

const { trackGtm } = require('../../../../js/functions');

const CLASS_NOT_CURRENT = 'not-current';
const CLASS_CURRENT = 'current';

module.exports = {
	async init() {
		this.highlights = this.root.querySelectorAll('.section-highlight');
		await asyncImport(this, ['anime', 'Hammer']);
		onWidthResize(this.resize.bind(this), stuttering.DEBOUNCE, DELAY_DEBOUNCE);

		this.resize();
		this.track();
	},
	resize() {
		if (mediaQueryMin(breakSmall)) {
			// desktop
			// check if coming from mobile
			this.clean();
			if (this.touch)
				this.touch.set({
					enable: false,
				});
		} else {
			// mobile
			// if not initialized, initialise
			if (!this.mobileinitialized) {
				this.mobileInit();
			} else {
				this.update(0);
				this.touch.set({
					enable: true,
				});
			}
			this.updateContentSize();
		}
	},
	mobileInit() {
		this.dots = this.root.getElementsByClassName('carousel-dot');
		this.contentSlot = this.root.querySelector(
			'.section-highlights--content-slot',
		);
		this.counter = this.root.querySelector('.section-highlights--counter');
		this.total = this.dots.length;
		this.current = 0;

		// one slide case
		if (this.total < 2) {
			this.counter.classList.add(CLASS_NO_DISPLAY);
			this.root
				.querySelector('.section-highlights--dots')
				.classList.add(CLASS_NO_DISPLAY);
			this.highlights[0].querySelector(
				'.section-highlight--content',
			).style.opacity = 1;
			this.highlights[0].querySelector(
				'.section-highlight--picture',
			).style.opacity = 1;
			this.updateContentSize();
			return;
		}

		this.touchInit();
		this.mobileinitialized = true;
		this.update(0);
	},
	touchInit() {
		this.touch = new this.Hammer(this.root);
		this.touch.on('swipeleft', () => {
			this.increment();
		});
		this.touch.on('swiperight', () => {
			this.decrement();
		});
	},
	getNext() {
		if (this.current >= this.total - 1) return 0;
		else return this.current + 1;
	},
	getPrevious() {
		if (this.current <= 0) return this.total - 1;
		else return this.current - 1;
	},
	increment() {
		this.forwardDirection = true;
		this.update(this.getNext());
		this.forwardDirection = undefined;
	},
	decrement() {
		this.forwardDirection = false;
		this.update(this.getPrevious());
		this.forwardDirection = undefined;
	},
	updateContentSize() {
		const highlight = this.highlights[this.current].getElementsByClassName(
			'section-highlight--content',
		)[0];
		const height = highlight.clientHeight;

		this.anime({
			targets: this.contentSlot,
			easing: MAIN_EASING,
			duration,
			height,
		});
	},
	getDirection(current) {
		let forwardDirection;
		if (this.forwardDirection !== undefined) {
			forwardDirection = this.forwardDirection;
		} else {
			forwardDirection = current > this.current;
			if (Math.abs(current - this.current) > 1)
				forwardDirection = !forwardDirection;
		}
		return forwardDirection;
	},
	animateSlide(highlight, previousHighlight, forwardDirection) {
		this.animations = [
			this.anime({
				targets: highlight.querySelector('.section-highlight--content'),
				opacity: [0, 0.01, 1],
				translateX: forwardDirection
					? [window.innerWidth, 0]
					: [-window.innerWidth, 0],
				duration,
				easing: 'linear',
			}),
			this.anime({
				targets: previousHighlight.querySelector('.section-highlight--content'),
				translateX: forwardDirection
					? [0, -window.innerWidth]
					: [0, window.innerWidth],
				opacity: [1, 0.01, 0],
				duration,
				easing: 'linear',
			}),
			this.anime({
				targets: highlight.querySelector('.section-highlight--picture'),
				opacity: [0, 1],
				duration,
				easing: 'linear',
			}),
			this.anime({
				targets: previousHighlight.querySelector('.section-highlight--picture'),
				opacity: [1, 0],
				duration,
				easing: 'linear',
			}),
		];
	},
	setCurrent(current) {
		this.highlights.forEach(highlight => {
			if (highlight === current) {
				highlight.classList.add(CLASS_CURRENT);
				highlight.classList.remove(CLASS_NOT_CURRENT);
			} else {
				highlight.classList.add(CLASS_NOT_CURRENT);
				highlight.classList.remove(CLASS_CURRENT);
			}
		});
	},
	update(current) {
		const dot = this.dots[current];
		const previousDot = this.dots[this.current];
		const highlight = this.highlights[current];
		const previousHighlight = this.highlights[this.current];
		this.setCurrent(highlight);

		if (this.current !== current) {
			const forwardDirection = this.getDirection(current);
			this.animateSlide(highlight, previousHighlight, forwardDirection);
		} else {
			highlight.querySelector('.section-highlight--content').style.opacity = 1;
			highlight.querySelector('.section-highlight--picture').style.opacity = 1;
		}

		previousDot.classList.remove('active');
		dot.classList.add('active');

		this.current = current;
		this.updateContentSize();

		// update counter in the middle
		setTimeout(() => {
			this.counter.innerHTML = `${this.current + 1} / ${this.total}`;
		}, duration / 2);
	},
	clean() {
		if (this.highlights) {
			Array.from(this.highlights).forEach(highlight => {
				const content = highlight.querySelector('.section-highlight--content');
				const picture = highlight.querySelector('.section-highlight--picture');
				highlight.classList.remove(CLASS_NOT_CURRENT);
				content.removeAttribute('style');
				picture.removeAttribute('style');
			});
		}
		if (this.animations) {
			this.animations.forEach(animation => {
				animation.pause();
			});
		}
	},

	track() {
		this.highlights.forEach(highlight => {
			const widgetTitle = this.root.querySelector(
				'.section-highlights--title',
			)?.innerHTML;
			const link = highlight.querySelector('.section-highlight--link');
			highlight.addEventListener('click', () => {
				trackGtm({
					eventCategory: 'cta',
					eventAction: 'read',
					eventLabel: link.href,
				});
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: 'V3-Section highlight',
					widget_title: widgetTitle ? widgetTitle : 'No title: Title not set',
					link_text: link.innerHTML ? link.innerHTML : 'No text; Text not set',
					link_url: link.href,
					button_type: '',
				});
			});
		});
	},
};
